<!-- Unified navigation template -->
<ng-container *ngFor="let navigation of navigations">
  <li class="nav-item" routerLinkActive="active">
    <a
      class="nav-link nav-toggle collapsed"
      [href]="isFromLayout ? getNavigationHref(navigation) : '#TableId-' + (navigation?.LevelIds?.TableId || navigation.Order)"
      data-toggle="collapse"
      aria-expanded="false"
      aria-controls="category-three"
      [matTooltip]="navigation.Title"
      matTooltipPosition="after"
      (keydown)="$event.preventDefault()"
    >
      <ng-container
        *ngTemplateOutlet="iconTemplate; context: { item: navigation, isTopLevel: true }"
      ></ng-container>
      <span class="text-collapse-menu">
        <span>{{ navigation.Title }}</span>
        <span *ngIf="navigation?.Items?.length" class="arrow-span">
          <i class="icon-chv-right"></i>
        </span>
      </span>
    </a>
    <div
      class="collapse"
      routerLinkActive="show"
      id="TableId-{{ navigation?.LevelIds?.TableId || navigation.Order }}"
      data-parent="#menu-collapse"
    >
      <ul class="nav sub-nav">
        <ng-container *ngFor="let Item of navigation.Items">
          <li class="nav-item" [ngClass]="{ active: getRouterLink(Item) === activeLink }">
            <!-- Case 1: Router link within the same app -->
            <a
              *ngIf="(Item.TableId || fromSameApp(Item)) && !Item.OpenNewWindow"
              routerLink="{{ getRouterLink(Item) }}"
              href="javascript:void(0)"
              class="nav-link"
              title="{{ Item.Title }}"
            >
              <ng-container
                *ngTemplateOutlet="iconTemplate; context: { item: Item, isTopLevel: false }"
              ></ng-container>
            </a>
            <!-- Case 2: External link without new window -->
            <a
              *ngIf="(!Item.TableId && !fromSameApp(Item)) && !Item.OpenNewWindow"
              href="javascript:void(0)"
              class="nav-link"
              (click)="openLink(Item)"
              title="{{ Item.Title }}"
            >
              <ng-container
                *ngTemplateOutlet="iconTemplate; context: { item: Item, isTopLevel: false }"
              ></ng-container>
            </a>
            <!-- Case 3: Link opens in new window -->
            <div
              *ngIf="!(Item.TableId && fromSameApp(Item)) && Item.OpenNewWindow"
              class="nav-link custom-link"
              (click)="openLinkInNewTab(Item)"
              (keydown)="$event.preventDefault()"
            >
              <ng-container
                *ngTemplateOutlet="iconTemplate; context: { item: Item, isTopLevel: false }"
              ></ng-container>
            </div>
          </li>
        </ng-container>
      </ul>
    </div>
  </li>
</ng-container>

<!-- Reusable icon template for both navigation and sub-navigation items -->
<ng-template #iconTemplate let-item="item" let-isTopLevel="isTopLevel">
  <span class="icon-nav">
    <ng-container
      *ngIf="!item.Logo && !(item.Icon?.includes('fluent-') || item.Icon?.includes('fl-') || item.Icon?.includes('material'))"
    >
      <!-- Top-level default icon (folder SVG or icon) -->
      <ng-container *ngIf="isTopLevel">
        <i
          class="icon-folder-open"
          [style.color]="isOpenGovTheme ? '#000' : '#fff'"
        ></i>
      </ng-container>
      <!-- Sub-level default icon -->
      <span
        *ngIf="!isTopLevel"
        [class]="getNavItemIcon(item.Icon)"
      >
        <span class="path"></span>
      </span>
    </ng-container>
    <!-- Fluent or Material icon -->
    <i
      *ngIf="item.Icon?.includes('fluent-') || item.Icon?.includes('fl-') || item.Icon?.includes('material')"
      [class]="item.Icon"
      [ngStyle]="{
        'font-size': '24px',
        'color': item.IconColor === '#fff' && isOpenGovTheme ? '#000' : item.IconColor
      }"
    ></i>
    <!-- Logo image -->
    <img
      *ngIf="item.Logo && !(item.Icon?.includes('fluent-') || item.Icon?.includes('fl-') || item.Icon?.includes('material'))"
      [src]="item.Logo"
      alt="logo"
      [style.width]="isTopLevel ? '24px' : '20px'"
      [style.minWidth]="!isTopLevel ? '20px' : null"
    />
  </span>
  <!-- Title for sub-navigation items -->
  <span *ngIf="!isTopLevel" class="text-collapse-menu">{{ item.Title }}</span>
</ng-template>